import { defineStore } from 'pinia';

const THEME_KEY = 'theme';

function normalizeTheme(value) {
  return value === 'dark' ? 'dark' : 'light';
}

function applyTheme(mode) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', mode);
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    mode: 'light'
  }),
  getters: {
    isDark: (state) => state.mode === 'dark'
  },
  actions: {
    initTheme() {
      const stored = localStorage.getItem(THEME_KEY);
      this.mode = normalizeTheme(stored);
      applyTheme(this.mode);
    },
    setTheme(mode) {
      this.mode = normalizeTheme(mode);
      localStorage.setItem(THEME_KEY, this.mode);
      applyTheme(this.mode);
    },
    toggleTheme() {
      this.setTheme(this.mode === 'dark' ? 'light' : 'dark');
    }
  }
});
